
import { defineComponent, reactive, PropType } from 'vue'
import SettingPanelKamokuList from '@/views/fuzoku-meisai/SettingPanelKamokuList.vue'
import SettingPanelButtons from '@/views/fuzoku-meisai/SettingPanelButtons.vue'
import { Kamoku, ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'

interface State {
  selectedSourceItem: Kamoku | null;
  selectedTargetItem: Kamoku | null;
}

function sortSettingItem (settingItem: ResponseSettingItem) {
  const sortFunc = (item1: Kamoku, item2: Kamoku): number => {
    if (item1.order > item2.order) {
      return 1
    } else if (item1.order < item2.order) {
      return -1
    } else {
      return 0
    }
  }

  settingItem.sources = settingItem.sources.sort(sortFunc)
  settingItem.targets = settingItem.targets.sort(sortFunc)
}

function getSelectedItemIndex (item: Kamoku, settingItem: Array<Kamoku>) {
  return settingItem.findIndex(value => {
    return value.kmkKbnCode === item.kmkKbnCode &&
      value.knjKmkCode === item.knjKmkCode &&
      value.hojoCode === item.hojoCode
  })
}

function moveToTargetItem (item: Kamoku, settingItem: ResponseSettingItem) {
  settingItem.targets.push(item)
  settingItem.sources = settingItem.sources.filter(one => {
    return one.kmkKbnCode !== item.kmkKbnCode ||
      one.knjKmkCode !== item.knjKmkCode ||
      one.hojoCode !== item.hojoCode
  })
  sortSettingItem(settingItem)
}

function moveToSourceItem (item: Kamoku, settingItem: ResponseSettingItem) {
  settingItem.sources.push(item)
  settingItem.targets = settingItem.targets.filter(one => {
    return one.kmkKbnCode !== item.kmkKbnCode ||
      one.knjKmkCode !== item.knjKmkCode ||
      one.hojoCode !== item.hojoCode
  })
  sortSettingItem(settingItem)
}

export default defineComponent({
  components: {
    SettingPanelButtons,
    SettingPanelKamokuList
  },

  props: {
    responseSettingItem: {
      type: Object as PropType<ResponseSettingItem>,
      required: true
    },
    panelName: {
      type: String,
      required: true
    }
  },

  emits: {
    updateSettingItem: (panelName: string, item: ResponseSettingItem) => true
  },

  setup (props, { emit }) {
    const state = reactive<State>({
      selectedSourceItem: null,
      selectedTargetItem: null
    })

    const selectedSourceItem = (item: Kamoku) => {
      state.selectedSourceItem = item
      state.selectedTargetItem = null
    }

    const selectedTargetItem = (item: Kamoku) => {
      state.selectedTargetItem = item
      state.selectedSourceItem = null
    }

    const addToTarget = () => {
      const selected = state.selectedSourceItem
      if (!selected) {
        return
      }

      let index = getSelectedItemIndex(selected, props.responseSettingItem.sources)
      moveToTargetItem(selected, props.responseSettingItem)

      state.selectedSourceItem = null
      if (index !== -1) {
        if (index === props.responseSettingItem.sources.length) {
          --index
        }
        state.selectedSourceItem = props.responseSettingItem.sources[index]
      }

      emit('updateSettingItem', props.panelName, props.responseSettingItem)
    }

    const removeFromTarget = () => {
      const selected = state.selectedTargetItem
      if (!selected) {
        return
      }

      let index = getSelectedItemIndex(selected, props.responseSettingItem.targets)
      moveToSourceItem(selected, props.responseSettingItem)

      state.selectedTargetItem = null
      if (index !== -1) {
        if (index === props.responseSettingItem.targets.length) {
          --index
        }
        state.selectedTargetItem = props.responseSettingItem.targets[index]
      }

      emit('updateSettingItem', props.panelName, props.responseSettingItem)
    }

    return {
      state,
      selectedSourceItem,
      selectedTargetItem,
      addToTarget,
      removeFromTarget
    }
  }
})
